import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/cast/Common";

export const RULES = [
  { t: "Point to Christ, not to yourself", d: "Share what God has done. Testimonies are text only; no links, contact details, or self-promotion." },
  { t: "No fundraising or recruitment", d: "No requests for money, donations, or invitations to outside groups, ministries, or channels." },
  { t: "Be kind across traditions", d: "Cast is broad-Christian. Discuss Scripture respectfully; don't attack or mock other denominations." },
  { t: "Honesty about who you are", d: "Usernames can be pseudonymous, but impersonation, deception, or fake ministries are removed." },
  { t: "Care with heavy stories", d: "Stories about abuse, addiction, crime, or mental health are welcome and shown with a gentle content notice." },
  { t: "Adults only in the community", d: "Children use Kids Cove for learning only. Never share a child's identifying details." },
  { t: "If someone is in danger", d: "Contact local emergency services first. Then report the post so moderators can help." },
  { t: "Report, don't retaliate", d: "Use Report and Block. Moderators review every report." },
];

export function RulesList() {
  return (
    <ol className="space-y-5" data-testid="rules-list">
      {RULES.map((r, i) => (
        <li key={r.t} className="flex gap-5">
          <span className="font-display text-3xl font-semibold text-[#C86D51]/60">{i + 1}</span>
          <div><p className="font-semibold text-slate-900">{r.t}</p><p className="text-slate-600">{r.d}</p></div>
        </li>
      ))}
    </ol>
  );
}

export function AcceptRules({ onDone }: { onDone?: () => void }) {
  const { refresh } = useAuth();
  const accept = async () => { try { await api.post("/me/accept-rules"); await refresh(); toast.success("Welcome to Cast Net"); onDone?.(); } catch (e) { toast.error(errMsg(e)); } };
  return <Button data-testid="accept-rules-button" onClick={accept} className="h-12 rounded-full bg-[#C86D51] px-8 text-base font-semibold hover:bg-[#B35A3F]">I agree to the community rules</Button>;
}

export default function Rules() {
  const { user } = useAuth();
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader metaphor="Cast Net" label="Community Rules" title="How we gather here." subtitle="Simple rules that keep Cast safe, honest, and centered on Scripture." />
      <div className="card-warm p-8 sm:p-10"><RulesList /></div>
      <div className="mt-8">{user.rules_accepted_at ? <p className="text-sm text-slate-500" data-testid="rules-accepted-note">You accepted these rules on {new Date(user.rules_accepted_at).toLocaleDateString()}.</p> : <AcceptRules onDone={() => nav("/cast-net")} />}</div>
    </div>
  );
}
